exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content {\n    padding: 10px 15px 10px 15px;\n    border-radius: unset;\n    height: 100%;\n}\n", ""]);

// exports
